import React from 'react';

function Row({
	children,
	indent,
	...otherProps
}: {
	children: React.ReactNode;
	indent?: boolean;
}) {
	return (
		<div className={`${indent ? 'ml-4 ' : ''}row`} {...otherProps}>
			<span className="text">{children}</span>
		</div>
	);
}

export default Row;
